import { render, staticRenderFns } from "./DialogReport.vue?vue&type=template&id=58db3a30&scoped=true"
import script from "./DialogReport.vue?vue&type=script&lang=js"
export * from "./DialogReport.vue?vue&type=script&lang=js"
import style0 from "./DialogReport.vue?vue&type=style&index=0&id=58db3a30&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58db3a30",
  null
  
)

export default component.exports